import { useCallback } from 'react';
import logger from 'services/logger';

/**
 * useLogger Hook
 *
 * Hook para acceder al servicio de logging desde componentes React
 *
 * @example
 * const { logError, logWarn, logInfo, getLogs, exportLogs } = useLogger();
 *
 * // Registrar un error
 * try {
 *   // código que puede fallar
 * } catch (error) {
 *   logError('Error al procesar datos', error, { userId: user.id });
 * }
 *
 * // Exportar logs para debugging
 * exportLogs();
 */
const useLogger = () => {
  const logError = useCallback((message, error, metadata = {}) => logger.error(message, error, metadata), []);

  const logWarn = useCallback((message, metadata = {}) => logger.warn(message, metadata), []);

  const logInfo = useCallback((message, metadata = {}) => logger.info(message, metadata), []);

  const logDebug = useCallback((message, metadata = {}) => logger.debug(message, metadata), []);

  const getLogs = useCallback((level = null) => logger.getLogs(level), []);

  const clearLogs = useCallback(() => logger.clearLogs(), []);

  const exportLogs = useCallback(() => logger.exportLogs(), []);

  return {
    logError,
    logWarn,
    logInfo,
    logDebug,
    getLogs,
    clearLogs,
    exportLogs
  };
};

export default useLogger;
